// extracted by mini-css-extract-plugin
module.exports = {"breakSmall":"767px","breakMedium":"1280px","container":"StaticPageTemplate_container__33PFC"};